import axios from "axios";
import "./MessageBox.css";
import { toast, ToastContainer } from "react-toastify";
import moment from "moment";
import "react-toastify/dist/ReactToastify.css";
import { useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { BsThreeDotsVertical } from "react-icons/bs";
import { TbMessage } from "react-icons/tb";
import { IoIosSend } from "react-icons/io";
import { MdInsertPhoto } from "react-icons/md";
import userProfile from "../../images/default/userProfile.png";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import ReactAudioPlayer from "react-audio-player";
// import audio from "./file_example_OOG_1MG.ogg"

const isLocalhost = window.location.hostname === "localhost";
const apiUrlImage = isLocalhost
  ? "http://localhost:3001/public/" // Local image path
  : "https://help-desk-backend-d3kq.onrender.com/Router/service/public/images/";

const MessageBox = ({ message }) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const [isMenuVisible, setMenuVisible] = useState(false);
  const [showRepliesModal, setShowRepliesModal] = useState(false);
  const [comment, setComment] = useState("");
  const [replyImage, setReplyImage] = useState(null);
  const staffName = useSelector((state) => state.staffname);
  const staffId = useSelector((state) => state.staffname);

  console.log(replyImage);

  const modalFileInputRef = useRef(null);

  const {
    image,
    contentType,
    createdDate,
    description,
    staffPic,
    page,
    colorCode,
    updatesHistory,
    replies = [],
  } = message;

  const toggleMenu = (e) => {
    e.stopPropagation();
    setMenuVisible(!isMenuVisible);
  };

  const handleMessageSend = async () => {
    if (!comment.trim() && !replyImage) {
      toast.warning("Type a comment or select an image.");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("staffName", staffName || "");
      formData.append("id", staffId || "");
      formData.append("staffPic", staffPic || "");
      formData.append("description", comment);
      formData.append("messageId", message._id);
      formData.append("image", replyImage);

      for (let pair of formData.entries()) {
        console.log(`${pair[0]}:`, pair[1]);
      }

      const response = await axios.post(`${apiUrl}reply`, formData);

      if (response.data.success) {
        toast.success("Reply Added");
        setReplyImage(null);
        setComment("");
        setShowRepliesModal(false);
      } else {
        toast.error("Failed to send reply");
      }
    } catch (err) {
      toast.error("Server error while sending reply");
    }
  };

  const handleDeleteMessage = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.delete(`${apiUrl}delete-message/${id}`);

        if (response.status === 200) {
          Swal.fire("Deleted!", "The message has been deleted.", "success");
          // 🔁 Optionally refresh data here
        } else {
          Swal.fire("Error", "Message not found.", "error");
        }
      } catch (error) {
        console.error("Delete error:", error);
        Swal.fire("Error", "Something went wrong!", "error");
      }
    }
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <Row>
        <Col className="mt-4">
          <div className="compact-enquiry-card ms-2">
            <div className="compact-header">
              <div className="compact-user-info">
                <div>
                  <div className="compact-user-name">
                    {updatesHistory.staff?.name}
                  </div>
                  <div className="compact-time">
                    {moment(createdDate).fromNow()}
                  </div>
                </div>
              </div>
              <div className="compact-dropdown">
                <span
                  className="compact-dropdown-label"
                  style={{ color: colorCode ? colorCode : "#000000" }}
                >
                  {page} / {updatesHistory.status}
                </span>
                <div className="menu-container">
                  <button className="menu-button" onClick={toggleMenu}>
                    <BsThreeDotsVertical />
                  </button>
                  {isMenuVisible && (
                    <div className="menu-popup">
                      {/* <label className="menu-item-recovery">
                        <input type="checkbox" /> Approved
                      </label> */}
                      <button
                        className="menu-item-recovery delete-btn"
                        onClick={() => handleDeleteMessage(message._id)}
                      >
                        Delete
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="recovery-content">
              <div className="d-flex">
                <img
                  src={staffPic ? apiUrlImage + staffPic: userProfile}
                  alt="User"
                  className="compact-user-icon"
                />
                <p>{description}</p>
              </div>
              {image && contentType !== "audio" && (
                <img
                  src={image}
                  // alt="Status Pic"
                  className="compact-user-image"
                  style={{ width: "450px", height: "250px" }}
                />
              )}
            
              {contentType === "audio" && (
                <ReactAudioPlayer src={image} autoPlay controls  className="custom-audio" />
              )}
            </div>

            <div className="recovery-footer">
              <div className="recovery-comments">
                <div className="comment-input-wrapper">
                  <input
                    type="text"
                    className="comment-input"
                    placeholder="Enter Comments"
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") handleMessageSend();
                    }}
                  />
                  <input
                    id="outer-image-upload"
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (file) {
                        setReplyImage(file); // ✅ store file
                        console.log("Outer image selected:", file);
                      }
                    }}
                  />

                  <label
                    htmlFor="outer-image-upload"
                    style={{ cursor: "pointer" }}
                  >
                    <MdInsertPhoto
                      className="image-icon"
                      style={{ color: replyImage ? "#0384fc" : "inherit" }} // 🎯 Change color based on state
                    />
                  </label>
                  <span className="send-icon mb-1" onClick={handleMessageSend}>
                    <IoIosSend />
                  </span>
                </div>

                <div className="comment-count ms-2">
                  <span
                    onClick={() => setShowRepliesModal(true)}
                    className="reply-icon-btn"
                  >
                    {replies.length} <TbMessage className="mt-1" />
                  </span>

                  {showRepliesModal && (
                    <div
                      className="replies-modal-overlay"
                      onClick={() => setShowRepliesModal(false)}
                    >
                      <div
                        className="replies-modal"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div className="reply-title">
                          <h4 className="reply-modal-title">Replies</h4>
                          <button
                            className="reply-modal-close-btn"
                            onClick={() => setShowRepliesModal(false)}
                          >
                            ✖
                          </button>
                        </div>

                        <div className="mt-5 reply-card-section">
                          {replies.length > 0 ? (
                            replies.map((reply) => (
                              <div key={reply._id} className="reply-card">
                                <div className="d-flex">
                                  <img
                                    src={reply.staffPic ? apiUrlImage + reply.staffPic : userProfile}
                                    alt="Reply"
                                    className="reply-image"
                                  />
                                  <p className="ms-3 mt-1">
                                    {" "}
                                    {reply.staff.name}
                                  </p>
                                </div>
                                {reply.image && reply.image.trim() !== "" && (
                                  <div>
                                    <img
                                      src={reply.image}
                                      alt=""
                                      className="mt-3"
                                      onError={(e) => {
                                        e.target.remove(); // Remove image element if it fails to load
                                      }}
                                      style={{
                                        width: "80%",
                                        height: "80%",
                                        marginLeft: "10%",
                                      }}
                                    />
                                  </div>
                                )}{" "}
                                <br></br>
                                <div>
                                  <p className="reply-desc">
                                    {reply.description}
                                  </p>
                                  <p className="reply-time">
                                    {moment(reply.createdDate).fromNow()}
                                  </p>
                                </div>
                              </div>
                            ))
                          ) : (
                            <p className="no-replies-text">No replies yet.</p>
                          )}
                        </div>

                        <div className="comment-input-wrapper-reply ms-0">
                          <input
                            type="text"
                            className="comment-input-in-reply"
                            placeholder="Enter Comments"
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") handleMessageSend();
                            }}
                          />
                          <input
                            type="file"
                            accept="image/*"
                            ref={modalFileInputRef}
                            onChange={handleMessageSend}
                            style={{ display: "none" }}
                          />
                          <span
                            onClick={() => modalFileInputRef.current?.click()}
                          >
                            <MdInsertPhoto className="image-icon" />
                          </span>
                          <span clName="send-icon" onClick={handleMessageSend}>
                            <IoIosSend />
                          </span>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* <div className="recovery-assigned">
                  Assigned By:{" "}
                  <span className="assigned-person">
                    {assignedBy}
                  </span>
                  <span className="assigned-date"> {assignedAt}</span>
                </div> */}
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default MessageBox;
